import { render, staticRenderFns } from "./checkbox-normal.vue?vue&type=template&id=4212b59a"
import script from "./checkbox-normal.vue?vue&type=script&lang=js"
export * from "./checkbox-normal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports